import { combineReducers } from '@reduxjs/toolkit';
import dialogReducer from './dialogReducer';
import csvDialogReducer from './csvDialogReducer';
import formViewDialog from './formViewDialogReducer';
// import userReducer from './userReducer';

import reportViewDialogReducer from './reportViewDialogReducer';
import filterParamsReducer from './filterParamsReducer';

const reducer = combineReducers({
	dialogReducer,
	// userReducer,
	csvDialogReducer,
	reportViewDialogReducer,
	filterParamsReducer,
	formViewDialog
});

export default reducer;
